export default {
	claimInfo: CLAIMINFO(),
	pwaApcnScrId: '', // pwa신청현황 화면 ID(품명 클릭시 부품검사 화면으로 이동하기 위해 필요함)
	//clmApcnScrId: '', // 클레임현황 화면 ID(품명 클릭시 부품검사 화면으로 이동하기 위해 필요함)
	clamRepayScrId: '', // 클레임현황 화면 ID(품명 클릭시 부품검사 화면으로 이동하기 위해 필요함)
	roApcnListScrId: '', // RO신청현황 화면 ID(품명 클릭시 부품검사 화면으로 이동하기 위해 필요함)
	rtnPartMstScrId: ''
};

function CLAIMINFO() {
	return {
		pwaApprCnt: '', //PWA - 승인건수
		pwaRjctCnt: '', // PWA - 기각건수
		pwaGvbkCnt: '', // PWA - 반려건수
		pwaCmptCnt: '', // PWA - 처리완료건수
		pwaPndgCnt: '', // PWA - 미결건수
		pwaWrtCnt: '', // PWA - 작성중
		pwaLtmCnt: '', // PWA - 장기미결(3일이상)
		pwaTotCnt: '', // PWA - 전체
		pwaPrcRt: '', // PWA - 처리율
		pwaLtm30Cnt: '', // PWA - 1개월 이내
		pwaLtm90Cnt: '', // PWA - 3개월 이내
		pwaLtmOverCnt: '', // PWA - 3개월 이상

		rptpNapprCnt: '',
		rptpApprCnt: '',
		rptpRecyCnt: '',
		rptpFinishCnt: '',

		clmApprCnt: '', // 클레임 - 승인건수
		clmRjctCnt: '', // 클레임 - 기각건수
		clmGvbkCnt: '', // 클레임 - 반려건수
		clmCmptCnt: '', // 클레임 - 처리완료건수
		clmPndgCnt: '', // 클레임 - 미결건수
		clmWrtCnt: '', // 클레임 - 작성중
		clmLtmCnt: '', // 클레임 - 장기미결(7일이내)
		clmTotCnt: '', // 클레임 - 전체
		clmPrcRt: '', // 클레임 - 처리율
		clmLtm30Cnt: '', // 클레임 - 1개월 이내
		clmLtm90Cnt: '', // 클레임 - 3개월 이내
		clmLtmOverCnt: '' // 클레임 - 3개월 이상
	};
}
export { CLAIMINFO };
